import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material';
import BaseModal from 'components/BaseModal';
import { CartAbandonmentDetailEnum } from 'enums';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onActionClick: PropTypes.func.isRequired,
};

export default function PaymentIssueModal({ open, onClose, onActionClick }) {
  const [detail, setDetail] = useState('');
  const [description, setDescription] = useState('');

  function handleActionClick() {
    onActionClick({ detail, description });

    setDetail('');
    setDescription('');
  }

  return (
    <BaseModal
      size="sm"
      open={open}
      title={
        <b>
          Let us know what's happening <br /> with your payment
        </b>
      }
      content={
        <Box px={2}>
          <Box display="flex" justifyContent="center" mb={4}>
            <RadioGroup value={detail} onChange={({ target: { value } }) => setDetail(value)}>
              <FormControlLabel
                label="I can't find a payment method that suits me"
                value={CartAbandonmentDetailEnum.MISSING_PAYMENT_METHOD}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="My credit card was declined"
                value={CartAbandonmentDetailEnum.CARD_DECLINED}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="My payment is taking too long to process"
                value={CartAbandonmentDetailEnum.SLOW_PROCESSING}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="Paypal can't validate my purchase"
                value={CartAbandonmentDetailEnum.PAYPAL_VALIDATION}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="Alipay can't validate my purchase"
                value={CartAbandonmentDetailEnum.ALIPAY_VALIDATION}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="Others"
                value={CartAbandonmentDetailEnum.OTHER}
                control={<Radio color="secondary" />}
              />
            </RadioGroup>
          </Box>

          <TextField
            fullWidth={true}
            multiline={true}
            variant="outlined"
            inputProps={{ minRows: 2 }}
            label="Tell us a little more about the problem."
            value={description}
            onChange={({ target: { value } }) => setDescription(value)}
          />
        </Box>
      }
      actionText="Share with us"
      disableActionButton={!detail}
      cancelButton={false}
      onActionClick={handleActionClick}
      onClose={onClose}
    />
  );
}

PaymentIssueModal.propTypes = Props;
